const normalizeText = (value) => String(value ?? '').trim();

const compareText = (a, b) =>
  normalizeText(a).localeCompare(normalizeText(b), undefined, {
    numeric: true,
    sensitivity: 'base',
  });

const compareSortValues = (aSort, bSort) => {
  if (typeof aSort === 'number' && typeof bSort === 'number') {
    return aSort - bSort;
  }

  return compareText(aSort, bSort);
};

export const compareLookupOptions = (
  a,
  b,
  {
    optionSortField,
    getLabel = (item) => item?.label ?? item?.name ?? '',
    getSortValue = (item, field) => item?.[field],
    compareFn,
  } = {},
) => {
  if (optionSortField) {
    const aSort = getSortValue(a, optionSortField);
    const bSort = getSortValue(b, optionSortField);
    const aHasSort = aSort !== undefined && aSort !== null && aSort !== '';
    const bHasSort = bSort !== undefined && bSort !== null && bSort !== '';

    if (aHasSort && bHasSort && aSort !== bSort) {
      return compareSortValues(aSort, bSort);
    }

    if (aHasSort !== bHasSort) {
      return aHasSort ? -1 : 1;
    }
  }

  if (typeof compareFn === 'function') {
    const customComparison = compareFn(a, b);
    if (customComparison !== 0) {
      return customComparison;
    }
  }

  const labelComparison = compareText(getLabel(a), getLabel(b));
  if (labelComparison !== 0) {
    return labelComparison;
  }

  return compareText(a?.value ?? a?.id, b?.value ?? b?.id);
};

export const sortLookupOptions = (items = [], options = {}) =>
  [...(Array.isArray(items) ? items : [])].sort((a, b) => compareLookupOptions(a, b, options));
